import { render, staticRenderFns } from "./YtKpiTile.vue?vue&type=template&id=583ecefe&scoped=true&"
import script from "./YtKpiTile.vue?vue&type=script&lang=js&"
export * from "./YtKpiTile.vue?vue&type=script&lang=js&"
import style0 from "./YtKpiTile.vue?vue&type=style&index=0&id=583ecefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ecefe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
